<template>
  <div>
    <div class="row">
      <players-waiting></players-waiting>
      <players-ready></players-ready>
    </div>
    <div v-if="player">
      <modal :show.sync="showModal" large="true" effect="fade" backdrop="false">
        <div slot="modal-header" class="modal-header">
          <h4 class="modal-title">Tarjeta de jugador</h4>
          <span v-show="show_spinner">
            <scale-loader></scale-loader>
          </span>
        </div>
        <div slot="modal-body" class="modal-body">
          <player :player="player"></player>
          <card-editor :show_player_cards="show_player_cards"></card-editor>
          <card :show_card="show_card"></card>
        </div>
        <div slot="modal-footer" class="modal-footer">
          <button type="button" class="btn btn-default" @click='closeModal'>Cerrar</button>
        </div>
      </modal>
    </div>
  </div>

</template>

<script>
  import configure from '../configure'
  import PlayersWaiting from '../components/PlayersWaiting.vue'
  import Card from '../components/Card.vue'
  import CardEditor from '../components/CardEditor.vue'
  import {modal} from 'vue-strap'
  import PlayersReady from '../components/PlayersReady.vue'
  import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
  import Player from '../components/Player.vue'
  import {
    getCurrentChampionship,
    getCurrentDate,
    getCurrentPlayer,
    getCardSaved,
    getShowPlayer,
    getShowCard,
    getShowPlayerCards,
    getLoading
  } from '../vuex/getters'
  import * as actions from '../vuex/actions'

  export default{
    components: {PlayersWaiting, Card, modal, PlayersReady, CardEditor, ScaleLoader, Player},
    vuex: {
      getters: {
        championship: getCurrentChampionship,
        date: getCurrentDate,
        player: getCurrentPlayer,
        card_saved: getCardSaved,
        show_player: getShowPlayer,
        show_card: getShowCard,
        show_player_cards: getShowPlayerCards,
        show_spinner: getLoading
      },
      actions: actions
    },
    computed: {
      show_lists() {
        return true
      },
      showModal() {
        return this.show_player
      }
    },
    methods: {
      closeModal() {
        this.showPlayerCards(false);
        this.showPlayer(false);
        this.showCard(false);
        this.initHoles();
      }
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** PlayersList.vue?7defa826
 **/